// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"DeleteIcon_closeIcon__3uwvH"};